import React from "react"
import { FormikAgentFormProps } from "../../AgentForm"
import { AgentValues } from "../../../../models/agent"
import { nameof } from "../../../../utility/common/nameof"
import DebouncedValidatableInput from "../../../ValidatableInput/DebouncedValidatableInput"
import DocLink from "../../../DocLink/DocLink"
import AgentFormWrapper from "../../../AgentFormWrapper/AgentFormWrapper"

const tNamespace = "agent:form."
const tLinkNamespace = "agent:link."

const FormikRemoteWorkplaceAgentFormGeneral: React.FC<FormikAgentFormProps> = props => {
    const { asyncState, agentType, t, handleSubmit, disabled } = props

    return (
        <AgentFormWrapper
            onSubmit={handleSubmit}
            disabled={disabled}
            loading={asyncState.inProcess}
            agentType={agentType}
        >
            <DocLink type={agentType}>{t(`${tLinkNamespace}creating-agent-instructions`)}</DocLink>
            <div className="agent-form__section">
                <DebouncedValidatableInput
                    id="formTitle"
                    type="text"
                    name={nameof<AgentValues>("Id")}
                    label={t(`${tNamespace}title`)}
                />
            </div>
        </AgentFormWrapper>
    )
}

export default FormikRemoteWorkplaceAgentFormGeneral
